import React, { useEffect, useRef, useState } from 'react';
import './ChatWidget.css'; // Renamed CSS file
import { ArrowCounterclockwise, Gear } from 'react-bootstrap-icons';
import axios from 'axios';
import { BASE_URL } from '../../Common/constant';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import defaultAvatar from './../../assets/Avatar/aimentor1.png'
// import FigureInfo from './FigureInfo';
import IntroScreen from './IntroScreen';
import MentorSelection from './MentorSelection';
import ChatInterface from './ChatInterface';

const ChatWidget = ({ userData }) => {

  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();

  const [step, setStep] = useState(1); 
  const [figures, setFigures] = useState([]);

  const [selections, setSelections] = useState({ figure: null });
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isInitializing, setIsInitializing] = useState(true);
  const [showFigureInfo, setShowFigureInfo] = useState([]);

  const [tasks, setTasks] = useState([]);
  const [isTasksExpanded, setIsTasksExpanded] = useState(false);

  const [canChangeMentor, setCanChangeMentor] = useState(false);
  const [nextChangeDate, setNextChangeDate] = useState(null);
  const [isChanging, setIsChanging] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  const [weeklyLimitReached, setWeeklyLimitReached] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState({
    isOpen: false,
    title: "",
    message: "",
    confirmBtnText: "Confirm",
    confirmBtnColor: "#d63384", // Default pink
    onConfirm: null, // The function to run
  });

  const token = localStorage.getItem('token');
  const isLoggedIn = userData || token;

  const activeMentor = selections.figure 
    ? figures.find(f => f.id === selections.figure.id) 
    : null;

  const activeMentorImage = activeMentor && activeMentor.image 
    ? `https://backend.parabyte.media${activeMentor.image}` 
    : defaultAvatar;

  const getAuthHeaders = () => {
    let token = localStorage.getItem('token');
    if (token) token = token.replace(/^"|"$/g, '');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
  };

  // Fetch Mentor List
  useEffect(() => {
    axios.get(`${BASE_URL}/chat/mentors`, getAuthHeaders())
      .then(response => {
        setFigures(response.data);
      })
      .catch(error => {
        console.error("Error fetching mentors:", error);
      })
  }, []);

  // Fetch Chat State (Intro Page/Select Mentor Page/ Chat Page)
  useEffect(() => {
    if (!isLoggedIn) {
        navigate('/startfree'); 
        return;
    }

    const fetchChatState = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/chat/state`, getAuthHeaders());
        setStep(res.data.step);
        setSelections({ figure: res.data.selections.figure });
        setMessages(res.data.messages);

        setCanChangeMentor(res.data.can_change_mentor);
        setNextChangeDate(res.data.next_change_date);

      } catch (error) {
        console.error('Error fetching chat state:', error);
      } finally {
        setIsInitializing(false); 
      }
    };

    fetchChatState();
  }, [token, isLoggedIn, navigate]);

  const updateBackendState = async (newStep, newFigureId) => {
    try {
      await axios.post(`${BASE_URL}/chat/state`, {
        step: newStep,
        figure_id: newFigureId
      }, getAuthHeaders());
    } catch (error) {
      console.error('Error updating chat state:', error);
    }
  };

  const handleStartSelection = () => {
    setStep(2);
    updateBackendState(2, null);
  }

  const handleFigureSelect = (figure) => {
    setSelections({ figure: figure });
    setMessages([]);
    setTasks([]);
    setStep(3);

    // if (messages.length === 0) {
    //   const pronoun = figure.gender === 'male' ? 'ကျွန်တော်' : 'ကျွန်မ';
    //   const defaultGreeting = {
    //     role: 'assistant',
    //     content: `မင်္ဂလာပါ။ ${pronoun}က <b>${figure.name}</b> ကို အခြေခံဖန်တီးထားတဲ့ AI Mentor ပါ။ ပထမဆုံးအနေနဲ့ မိတ်ဆွေ စိတ်ဝင်စားတဲ့ နယ်ပယ် (သို့မဟုတ်) လက်ရှိ အလုပ်အကိုင်ကို ပြောပြပေးနိုင်မလား။`
    //   };
      
    //   setMessages([defaultGreeting]);
    // }
    updateBackendState(3, figure.id);
  }

  const handleSendMessage = async (overrideMessage = null, isHidden = false) => {
    const textToSend = overrideMessage || inputValue;

    // Validation: Stop if both are empty
    if (!textToSend || !textToSend.trim()) return;

    if (!isHidden) {
      const userMsg = { role: 'user', content: textToSend };
      setMessages(prev => [...prev, userMsg]);
      setInputValue('');
    }
    setIsLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}/chat/message`, { message: textToSend }, getAuthHeaders());
      const botMsg = { role: 'assistant', content: response.data.reply };
      
      setMessages(prev => {
        const newMsgs = [...prev, botMsg];
        
        if (response.data.extra_message) {
          newMsgs.push({ role: 'assistant', content: response.data.extra_message });
        }
        return newMsgs;
      });

      if (response.data.extra_message) {
        fetchTasks(); 
      }

    } catch (error) {
      setIsLoading(false);
        
      if (error.response && error.response.status === 403) {
        const data = error.response.data;  
        if (data.error === 'Weekly session limit reached') {
          setWeeklyLimitReached(true);
                
          setMessages(prev => [...prev, { 
            role: 'system', 
            content: `<span style="color:#dc3545">⛔ ${data.message}</span>` 
          }]);
          return;
        }
      }
      console.error('Error sending message:', error);
      setMessages(prev => [...prev, { role: 'assistant', content: 'Error connecting to server.' }]);

    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (step === 3) {
      fetchTasks();
    }
  }, [step]);

  const fetchTasks = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/chat/tasks`, getAuthHeaders());
      setTasks(res.data);
    } catch (err) {
      console.error("Error loading tasks", err);
    }
  };

  const handleCompleteTask = async (taskId) => {
    // Optimistic UI Update
    const originalTasks = [...tasks];
    setTasks(tasks.filter(t => t.id !== taskId));

    try {
      const res = await axios.post(`${BASE_URL}/chat/tasks/${taskId}/complete`, {}, getAuthHeaders());
      if (res.data.reply) {
         setMessages(prev => [...prev, { role: 'assistant', content: res.data.reply }]);
      }

    } catch (error) {
      console.error("Failed to complete task", error);
      setTasks(originalTasks);
    }
  };

  const performChangeMentor = async () => {

    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    setIsChanging(true);

    try {
      await axios.post(`${BASE_URL}/chat/change-mentor`, {}, getAuthHeaders());
      window.location.reload(); 

    } catch (error) {
      alert(error.response?.data?.message || "Failed to change mentor");
      setIsChanging(false);
    }

  };

  const performResetChat = async () => {

    setConfirmationModal(prev => ({ ...prev, isOpen: false }));
    try {
      await axios.post(`${BASE_URL}/chat/reset`, {}, getAuthHeaders());
      window.location.reload(); 

    } catch (error) {
      console.error("Reset failed", error);
    }
  };

  const initiateChangeMentor = () => {

    setConfirmationModal({
      isOpen: true,
      title: "Change Mentor?",
      message: "This will clear your current chat history and you cannot switch again for 2 months. Are you sure?",
      confirmBtnText: "Yes, Change Mentor",
      confirmBtnColor: "#d63384", // Pink

      onConfirm: performChangeMentor
    });

  };

  const initiateResetChat = () => {

    setConfirmationModal({
      isOpen: true,
      title: "Reset Conversation?",
      message: "This will delete all messages in this chat permanently. You will stay with the current mentor.",
      confirmBtnText: "Yes, Reset Chat",
      confirmBtnColor: "#dc3545", // Red

      onConfirm: performResetChat
    });

  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (!isLoggedIn) return null;

  return (
    <div className="chat-page-container">
      
      {/* Header */}
      <div className="chat-page-header">
        <div className='chat-header'>
          {step === 3 && <img src={activeMentorImage} className='chat-head' alt={activeMentor ? activeMentor.name : "Mentor"} />}
          <h3>
            {step === 1 && 'AI Mentor'}
            {step === 2 && 'Select Mentor'}
            {step === 3 && 'AI Mentor'}
          </h3>
        </div>
        <div className="header-actions">
          {step === 3 && messages.length > 0 && (
            <div className='setting'>
              <button 
                onClick={() => setShowSettings(!showSettings)} 
                className={`icon-btn ${showSettings ? 'active' : ''}`} 
                title="Mentor Settings"
                style={{ marginRight: '10px' }}
              >
                <Gear size={20} />
              </button>

              {/* Reset Button */}
              <button onClick={initiateResetChat} className="icon-btn" title="Reset Chat">
                <ArrowCounterclockwise size={20} /> <span className="reset-text">Reset</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Body Content */}
      <div className="chat-page-body">
        {isInitializing ? (
          <div className="loading-container" style={{ padding: '40px', textAlign: 'center' }}>
            <div className="spinner-border" role="status" style={{color: '#346387'}}>
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
        <>
          {step === 1 && (
            <IntroScreen onStart={() => handleStartSelection()} />
          )}

          {step === 2 && (
              <MentorSelection 
                figures={figures} // or MOCK_FIGURES
                onFigureSelect={handleFigureSelect}
                onShowInfo={setShowFigureInfo}
                showFigureInfo={showFigureInfo}
                onCloseInfo={() => setShowFigureInfo({})}
              />
          )}

          {step === 3 && (
              <ChatInterface 
                messages={messages}
                isLoading={isLoading}
                inputValue={inputValue}
                setInputValue={setInputValue}
                handleSendMessage={handleSendMessage}
                tasks={tasks}
                isTasksExpanded={isTasksExpanded}
                setIsTasksExpanded={setIsTasksExpanded}
                handleCompleteTask={handleCompleteTask}
                weeklyLimitReached={weeklyLimitReached}
                showSettings={showSettings}
                setShowSettings={setShowSettings}
                canChangeMentor={canChangeMentor}
                isChanging={isChanging}
                initiateChangeMentor={initiateChangeMentor}
                nextChangeDate={nextChangeDate}
              />
          )}

          {confirmationModal.isOpen && (
            <div className="modal-overlay fade-in" style={{
              position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
              background: 'rgba(0,0,0,0.5)', zIndex: 9999,
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              
              <div className="modal-box" style={{
                background: 'white', padding: '25px', borderRadius: '12px',
                width: '90%', maxWidth: '400px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                textAlign: 'center'
              }}>
                
                <h5 style={{ margin: '0 0 10px 0', color: '#333', fontWeight: 'bold' }}>
                  {confirmationModal.title}
                </h5>
                
                <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
                  {confirmationModal.message}
                </p>

                <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                  {/* Cancel Button */}
                  <button 
                    onClick={() => setConfirmationModal(prev => ({ ...prev, isOpen: false }))}
                    style={{
                      padding: '8px 20px', borderRadius: '6px', border: '1px solid #ddd',
                      background: 'white', color: '#555', cursor: 'pointer', fontWeight: '600'
                    }}
                  >
                    Cancel
                  </button>

                  {/* Confirm Button */}
                  <button 
                    onClick={confirmationModal.onConfirm}
                    style={{
                      padding: '8px 20px', borderRadius: '6px', border: 'none',
                      background: confirmationModal.confirmBtnColor, 
                      color: 'white', cursor: 'pointer', fontWeight: '600'
                    }}
                  >
                    {confirmationModal.confirmBtnText}
                  </button>
                </div>

              </div>
            </div>
          )}
          
        </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.phone.userData,
  };
};

export default connect(mapStateToProps)(ChatWidget);